module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="notify result-error-info">\n\n	<h3>'+
((__t=( __('result_error_title') ))==null?'':__t)+
'</h3>\n\n	<p>'+
((__t=( __('result_error_subtitle') ))==null?'':__t)+
'</p>\n	<ul>\n		';
 _.each(errors, function(e) { 
__p+='\n		<li>'+
((__t=( e ))==null?'':__t)+
'</li>\n		';
 }) 
__p+='\n	</ul>\n\n	<p>'+
((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
'</p>\n\n	<button class="btn-reset">'+
((__t=( __('reset_search') ))==null?'':__t)+
'</button>\n\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/engine/result-error-validate.html
 ** module id = 63
 ** module chunks = 0
 **/